export default __webpack_public_path__ + "static/media/Jea_Chest.fff07341.png";